import {
  ALLOWED_ENTITY_SYNC_CONFIG_ENTITIES,
  type EntitySyncConfigurationEntityEnum,
} from '../enums/EntitySyncConfigurationEntityEnum'

export interface EntitySyncConfigurationConstructor {
  id: string // uuid
  entity: EntitySyncConfigurationEntityEnum
  isEnabled: boolean
  lastSync?: Nullable<ISODateString>
}

export class EntitySyncConfiguration {
  readonly id: string
  readonly lastSync: Nullable<Date>
  readonly entity: EntitySyncConfigurationEntityEnum
  readonly isEnabled: boolean

  constructor(data: EntitySyncConfigurationConstructor) {
    this.id = data.id
    this.lastSync = data.lastSync ? new Date(data.lastSync) : null
    if (!ALLOWED_ENTITY_SYNC_CONFIG_ENTITIES.includes(data.entity)) {
      console.error(
        `Invalid entity type "${data.entity}" for EntitySyncConfiguration. Allowed types are: ${ALLOWED_ENTITY_SYNC_CONFIG_ENTITIES.join(', ')}.`
      )
    }
    this.entity = data.entity
    this.isEnabled = data.isEnabled
  }
}
